module.exports = __webpack_public_path__ + "static/maindashboard-historical-2-5c2aef10aad52e8dd71bfa4ea40a4980.png";